import axios from "axios";
import axiosUrl from "./axios.service";
import store from "../store";

const API_URL = axiosUrl.getAxiosUrl();

class StatsService {
  async getStatsLineGraphGeneral(year, months, customerOwnerId, customerType) {
    return await axios
      .get(API_URL + "stats/getGeneralStats", {
        params: {
          year: year.value,
          months: months.value + "",
          customerOwnerId: customerOwnerId.value,
          customerType: customerType.value
        }
      })
      .then(response => {
        store.commit("generalStats/updateChartData", response.data);
      });
  }

  async XgetStatsLineGraphGeneral(
    yearFrom,
    yearTo,
    monthFrom,
    monthTo,
    customerOwnerId,
    customerType
  ) {
    return await axios
      .get(API_URL + "stats/getGeneralStats", {
        params: {
          yearFrom: yearFrom.value,
          yearTo: yearTo.value,
          monthFrom: monthFrom.value,
          monthTo: monthTo.value,
          customerOwnerId: customerOwnerId.value,
          customerType: customerType.value
        }
      })
      .then(response => {
        store.commit("generalStats/updateChartData", response.data);
      });
  }

  async getGeneralStatsPieChartCustomerTypes(selectedCustomerOwnerId) {
    return await axios
      .get(API_URL + "stats/getCustomerTypesPieChartData", {
        params: {
          customerOwnerId:
            selectedCustomerOwnerId && selectedCustomerOwnerId != null
              ? selectedCustomerOwnerId.value
              : null
        }
      })
      .then(response => {
        store.commit(
          "generalStats/updateFullPieChartData",
          response.data.customersTypesCount
        );
      });
  }

  async getGeneralStatsForUsers(customerOwnerId, customerType) {
    return await axios
      .get(API_URL + "stats/getGeneralStatsUsers", {
        params: {
          customerOwnerId:
            customerOwnerId && customerOwnerId.value > 0
              ? customerOwnerId.value
              : null,
          customerType:
            customerType && customerType != null ? customerType.value : null
        }
      })
      .then(response => {
        store.commit(
          "generalStats/updateUserStatsGeneral",
          response.data.generalUserStats
        );
      });
  }

  async getInactiveUsersGraph(
    modelYearFrom,
    modelYearTo,
    modelMonthIdFrom,
    modelMonthIdTo
  ) {
    return await axios
      .get(API_URL + "stats/getInactiveUsersGraph", {
        params: {
          yearFrom: modelYearFrom.value,
          yearTo: modelYearTo.value,
          monthFrom: modelMonthIdFrom.value,
          monthTo: modelMonthIdTo.value
        }
      })
      .then(response => {
        store.commit(
          "generalStats/updateChartDataInactiveUsers",
          response.data
        );
      });
  }

  async getUsersStatsBoxes(customersList, selectedCustomerOwnerId, usersList) {
    return await axios
      .get(API_URL + "stats/getUsersStats", {
        params: {
          selectedCustomerOwnerId:
            selectedCustomerOwnerId && selectedCustomerOwnerId.value != null
              ? selectedCustomerOwnerId.value
              : null,
          customersList:
            customersList && customersList.value.length > 0
              ? customersList.value + ""
              : null,
          usersList:
            usersList && usersList.value.length > 0
              ? usersList.value + ""
              : null
        }
      })
      .then(response => {
        store.commit(
          "userStats/updateUserStatsBoxes",
          response.data.userStatsBoxes
        );
      });
  }

  async getUsersTableStats(usersList, selectedCustomersIds) {
    return await axios
      .get(API_URL + "stats/getUsersTableStats", {
        params: {
          usersList:
            usersList && usersList.value.length > 0
              ? usersList.value + ""
              : null,
          customersList:
            selectedCustomersIds && selectedCustomersIds.value.length > 0
              ? selectedCustomersIds.value + ""
              : null
        }
      })
      .then(response => {
        store.commit("userStats/updateTableStats", response.data.userStats);
      });
  }

  async getStatsLineGraphUsersGeneral(year, months, customerOwnerId) {
    return await axios
      .get(API_URL + "stats/getGeneralStats", {
        params: {
          year: year.value,
          months: months.value + "",
          customerOwnerId: customerOwnerId.value
        }
      })
      .then(response => {
        store.commit("userStats/updateChartDataBasic", response.data);
      });
  }

  async getUserVsisitsStats(
    modelYearFrom,
    modelYearTo,
    modelMonthIdFrom,
    modelMonthIdTo,
    users,
    customerOwnerId,
    selectedCustomersIds
  ) {
    return await axios
      .get(API_URL + "stats/getUserVsisitsStats", {
        params: {
          yearFrom: modelYearFrom.value,
          yearTo: modelYearTo.value,
          monthFrom: modelMonthIdFrom.value,
          monthTo: modelMonthIdTo.value,
          users: users.value + "",
          customers: selectedCustomersIds.value + "",
          customerOwnerId: customerOwnerId.value
        }
      })
      .then(response => {
        store.commit("userStats/updateChartDataSchemeVisits", response.data);
      });
  }

  async getUserNewsVsisitsStats(
    modelYearFrom,
    modelYearTo,
    modelMonthIdFrom,
    modelMonthIdTo,
    users,
    customerOwnerId,
    selectedCustomersIds
  ) {
    return await axios
      .get(API_URL + "stats/getUserNewsVsisitsStats", {
        params: {
          yearFrom: modelYearFrom.value,
          yearTo: modelYearTo.value,
          monthFrom: modelMonthIdFrom.value,
          monthTo: modelMonthIdTo.value,
          users: users.value + "",
          customers: selectedCustomersIds.value + "",
          customerOwnerId: customerOwnerId.value
        }
      })
      .then(response => {
        store.commit("userStats/updateChartDataNewsVisits", response.data);
      });
  }

  async getGeneralUsersGraph(
    modelYearFrom,
    modelYearTo,
    modelMonthIdFrom,
    modelMonthIdTo,
    users,
    customerOwnerId,
    selectedCustomersIds
  ) {
    return await axios
      .get(API_URL + "stats/getGeneralUsersGraph", {
        params: {
          yearFrom: modelYearFrom.value,
          yearTo: modelYearTo.value,
          monthFrom: modelMonthIdFrom.value,
          monthTo: modelMonthIdTo.value,
          users: users.value + "",
          customers: selectedCustomersIds.value + "",
          customerOwnerId: customerOwnerId.value
        }
      })
      .then(response => {
        store.commit("userStats/updateChartDataBasic", response.data);
      });
  }

  async getPortalBoxesData(
    yearFrom,
    yearTo,
    monthFrom,
    monthTo,
    selectedCustomersIds,
    selectedPortalUsersIds
  ) {
    return await axios
      .get(API_URL + "stats/getPortalBoxesData", {
        params: {
          yearFrom: yearFrom.value,
          yearTo: yearTo.value,
          monthFrom: monthFrom.value,
          monthTo: monthTo.value,
          customers: selectedCustomersIds
            ? selectedCustomersIds.value + ""
            : null,
          users: selectedPortalUsersIds
            ? selectedPortalUsersIds.value + ""
            : null
        }
      })
      .then(response => {
        store.commit("portalStats/updateBoxesData", response.data);
      });
  }

  async getPortalBarGraphMain() {
    return await axios
      .get(API_URL + "stats/getPortalBarGraphMain")
      .then(response => {
        store.commit("portalStats/updateMainPortalGraph", response.data);
      });
  }

  async getPortalUsersGraph(
    yearFrom,
    yearTo,
    monthFrom,
    monthTo,
    selectedCustomersIds,
    selectedPortalUsersIds
  ) {
    return await axios
      .get(API_URL + "stats/getPortalUsersGraph", {
        params: {
          yearFrom: yearFrom.value,
          yearTo: yearTo.value,
          monthFrom: monthFrom.value,
          monthTo: monthTo.value,
          customers: selectedCustomersIds
            ? selectedCustomersIds.value + ""
            : null,
          users: selectedPortalUsersIds
            ? selectedPortalUsersIds.value + ""
            : null
        }
      })
      .then(response => {
        store.commit("portalStats/updateChartDataUsers", response.data);
      });
  }

  async getPortalVisitsGraph(
    yearFrom,
    yearTo,
    monthFrom,
    monthTo,
    selectedCustomersIds,
    selectedPortalUsersIds
  ) {
    return await axios
      .get(API_URL + "stats/getPortalVisitsGraph", {
        params: {
          yearFrom: yearFrom.value,
          yearTo: yearTo.value,
          monthFrom: monthFrom.value,
          monthTo: monthTo.value,
          customers: selectedCustomersIds
            ? selectedCustomersIds.value + ""
            : null,
          users: selectedPortalUsersIds
            ? selectedPortalUsersIds.value + ""
            : null
        }
      })
      .then(response => {
        store.commit("portalStats/updateChartDataVisits", response.data);
      });
  }

  async getPortalSchemeVisitsTable(
    yearFrom,
    yearTo,
    monthFrom,
    monthTo,
    customers,
    selectedPortalUsersIds
  ) {
    return await axios
      .get(API_URL + "stats/getPortalSchemeVisitsTable", {
        params: {
          yearFrom: yearFrom.value,
          yearTo: yearTo.value,
          monthFrom: monthFrom.value,
          monthTo: monthTo.value,
          customers: customers ? customers.value + "" : null,
          users: selectedPortalUsersIds
            ? selectedPortalUsersIds.value + ""
            : null
        }
      })
      .then(response => {
        store.commit(
          "portalStats/updateSchemeVisitsBarData",
          response.data.schemeVisits
        );
      });
  }

  async getPortalUsersTableExportable(selectedCustomersIds) {
    return await axios
      .get(API_URL + "stats/getPortalUsersTableExportable", {
        params: {
          customers: selectedCustomersIds
            ? selectedCustomersIds.value + ""
            : null
        }
      })
      .then(response => {
        store.commit(
          "portalStats/updatePortalUsersTableExportable",
          response.data.users
        );
      });
  }
  async exportGeneralStatsData() {
    return await axios.get(
      API_URL + "functionalitiesUse/exportGeneralStatsData",
      {
        responseType: "blob",
        reportProgress: true
      }
    );
  }

  async getPortalSchemePurposesCounts(
    yearFrom,
    yearTo,
    monthFrom,
    monthTo,
    customers,
    selectedPortalUsersIds
  ) {
    return await axios
      .get(API_URL + "stats/getPortalStatsPurposes", {
        params: {
          yearFrom: yearFrom.value,
          yearTo: yearTo.value,
          monthFrom: monthFrom.value,
          monthTo: monthTo.value,
          customers: customers ? customers.value + "" : null,
          users: selectedPortalUsersIds
            ? selectedPortalUsersIds.value + ""
            : null
        }
      })
      .then(response => {
        store.commit(
          "portalStats/updatePortalSchemePurposesData",
          response.data.purposes
        );
      });
  }

  // Consumption stats
  async getConsumptionStatsPurposes(
    yearFrom,
    yearTo,
    monthFrom,
    monthTo,
    customers
  ) {
    return await axios
      .get(API_URL + "stats/getConsumptionStatsPurposes", {
        params: {
          yearFrom: yearFrom.value,
          yearTo: yearTo.value,
          monthFrom: monthFrom.value,
          monthTo: monthTo.value,
          customers: customers ? customers.value + "" : null
        }
      })
      .then(response => {
        store.commit(
          "consumptionStats/updateConsumptionSchemePurposesData",
          response.data.purposes
        );
      });
  }

  async getNewAndEditSchemesCount(year, months) {
    return await axios
      .get(API_URL + "stats/getNewAndEditSchemesCount", {
        params: {
          year: year.value,
          months: months ? months.value + "" : null
        }
      })
      .then(response => {
        store.commit(
          "consumptionStats/updateNewAndEditedSchemesCounts",
          response.data
        );
      });
  }

  async getNewPublishedNews(year, months) {
    return await axios
      .get(API_URL + "stats/getNewPublishedNews", {
        params: {
          year: year.value,
          months: months ? months.value + "" : null
        }
      })
      .then(response => {
        store.commit("consumptionStats/updateNewsBarData", response.data.news);
      });
  }
  async getKeywordSearchTableConsumption() {
    return await axios
      .get(API_URL + "stats/getKeywordSearchTableConsumption")
      .then(response => {
        store.commit(
          "consumptionStats/updateKeywordSearchTable",
          response.data
        );
      });
  }
  async getSchemeVisitsTableConsumption() {
    return await axios
      .get(API_URL + "stats/getSchemeVisitsTableConsumption")
      .then(response => {
        store.commit("consumptionStats/updateSchemeVisitsTable", response.data);
      });
  }

  async getNewsVisitsTableConsumption() {
    return await axios
      .get(API_URL + "stats/getNewsVisitsTableConsumption")
      .then(response => {
        store.commit("consumptionStats/updateNewsVisitsTable", response.data);
      });
  }

  async getSchemesNewsVisitsConsumption() {
    return await axios
      .get(API_URL + "stats/getSchemesNewsVisitsConsumption")
      .then(response => {
        store.commit("consumptionStats/updateChartData", response.data);
      });
  }

  async getSchemesAndNewsConsumptionGraph() {
    return await axios
      .get(API_URL + "stats/getSchemesAndNewsConsumptionGraph")
      .then(response => {
        store.commit(
          "consumptionStats/updateSchemesAndNewsBarData",
          response.data
        );
      });
  }

  async getGeneralPortalStats() {
    return await axios
      .get(API_URL + "stats/getGeneralPortalStats")
      .then(response => {
        store.commit("generalStats/updateGeneralPortalStats", response.data);
      });
  }

  // Onze stats

  async getOnzeBoxesData(consultantIds, team) {
    return await axios
      .get(API_URL + "stats/getOnzeBoxesData", {
        params: {
          consultants: consultantIds ? consultantIds + "" : null,
          team: team ? team : ""
        }
      })
      .then(response => {
        store.commit("onzeStats/updateBoxesData", response.data);
      });
  }

  async getOnzeBar(consultantIds, team) {
    return await axios
      .get(API_URL + "stats/getOnzeBarGraph", {
        params: {
          consultants: consultantIds ? consultantIds + "" : null,
          team: team ? team : ""
        }
      })
      .then(response => {
        store.commit("onzeStats/updateBarData", response.data);
      });
  }

  async getOnzeTable(consultantIds, team) {
    return await axios
      .get(API_URL + "stats/getOnzeTableData", {
        params: {
          consultants: consultantIds ? consultantIds + "" : null,
          team: team ? team : ""
        }
      })
      .then(response => {
        store.commit("onzeStats/updateTableData", response.data);
      });
  }

  async getOnzeConsultants(team) {
    return await axios
      .get(API_URL + "stats/getConsultants", {
        params: {
          team: team
        }
      })
      .then(response => {
        store.commit("onzeStats/updateConsultants", response.data);
      });
  }

  async getDepartments() {
    return await axios.get(API_URL + "stats/getDepartments").then(response => {
      store.commit("onzeStats/updateDepartments", response.data);
    });
  }

  async getOBData(selectedTeam) {
    return await axios
      .get(API_URL + "stats/getOBData", {
        params: {
          department:
            selectedTeam && selectedTeam != null ? selectedTeam.value : null
        }
      })
      .then(response => {
        store.commit("onzeStats/updateOnzeBarData", response.data);
      });
  }

  async getPortalUsers() {
    return await axios.get(API_URL + "users/getPortalUsers").then(response => {
      store.commit("portalStats/updatePortalUsers", response.data);
    });
  }

  // FOMO stats
  async getFomoUsersTableStats(name) {
    return await axios
      .get(API_URL + "stats/getFomoUsersTableStats", {
        params: {
          usernameFilter: name
        }
      })
      .then(response => {
        store.commit("fomoStats/updateFomoUsersTableStats", response.data);
      });
  }

  // Filter clicks stats
  async exportFilterClicksStats() {
    return await axios.get(
      API_URL + "functionalitiesUse/exportFilterClicksStats",
      {
        responseType: "blob",
        reportProgress: true
      }
    );
  }
}

export default new StatsService();
